import { schemas } from 'constants/schemas';
import { normalize } from 'normalizr';
import { getCurrentLocale, isFetching } from 'selectors';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';
import {
  FETCH_COUNTRIES_FAILURE,
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_SUCCESS,
} from '../../../constants';

export const fetchCountries =
  locale =>
  (dispatch, getState, { apiV3 }) => {
    const state = getState();

    const isFetchingCountries = isFetching(state, 'countries');
    if (isFetchingCountries) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_COUNTRIES_REQUEST,
    });

    return apiV3.countries
      .fetch({ locale: locale || getCurrentLocale(state) })
      .then(response =>
        dispatch({
          type: FETCH_COUNTRIES_SUCCESS,
          payload: normalize(response, schemas.arrayOfCountries),
        }),
      )
      .catch(error => {
        errorNotifier.notify(error);
        dispatch({ type: FETCH_COUNTRIES_FAILURE });
      });
  };
